import { FirebaseError } from "firebase/app";

export const DEFAULT_MESSAGE =
  "An unknown error has occurred. Try again or try logging in another way.";

export const INVALID_EMAIL_ERROR_MESSAGE =
  "Email does not match the email that requested the sign in link. Check your email matches, or try logging in another way.";

export default function errorTranslator(error: unknown) {
  if (error instanceof FirebaseError) {
    if (error.code === "auth/invalid-action-code") {
      return "Sign in link has already been used.";
    }

    if (error.code === "auth/expired-action-code") {
      return "Sign in link has expired. Try again now, or log in another way.";
    }

    if (error.code === "auth/invalid-email") {
      return INVALID_EMAIL_ERROR_MESSAGE;
    }

    if (error.code === "auth/user-disabled") {
      return "User provided to sign in link is disabled.";
    }
  }
  return DEFAULT_MESSAGE;
}
